import useDeviceScreen from '../../../hooks/useDeviceScreen';
import Header, { HeaderLeft, HeaderRight } from '../../../layout/Header/Header';
import Navigation from '../../../layout/Navigation/Navigation';
import { pageLayoutTypesPagesMenu } from '../../../menu';

const DefaultHeader = () => {
	const { width } = useDeviceScreen();
	return (
		<Header>
			<HeaderLeft>
				<Navigation menu={{ ...pageLayoutTypesPagesMenu }} id='header-top-menu' horizontal={!!width && width >= Number(process.env.REACT_APP_MOBILE_BREAKPOINT_SIZE)} />
			</HeaderLeft>
			<HeaderRight>
				<span></span>
			</HeaderRight>
		</Header>
	);
};

export default DefaultHeader;
